module.exports = __webpack_public_path__ + "img/485932.b2fdc4f4.png";